/* global globals */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import tour from '../../../legacy/app/tour';
import responsiveness from '../../../../../sass/foundation/variables/responsiveness.scss';

const MatchesFooter = (props) => {
  const { pagination } = props;

  const matchesTour = (e) => {
    e.preventDefault();

    const mobile = _.get(globals, 'responsive', false) && window.innerWidth <= responsiveness.breakpoint;
    const bottomPosition = mobile ? 'bottom-window-middle-aligned' : 'bottom';
    // const topPosition = mobile ? 'top-window-middle-aligned' : 'top-middle-aligned';

    _.set(window, 'op_tour_params', {
      texts: {
        next: 'Sapratu',
        done: '✕',
        title: 'Rādīt saderību ceļvedi',
      },
      steps: [
        {
          intro: 'Apskati lietotājus, ar kuriem Tev izveidojusies saderība - abi esat novērtējuši viens otra profilu ar "Man patīk!".',
          element: document.querySelector('.matches-tour-matches'),
          position: bottomPosition,
          highlightClass: 'tourStep-highlight',
        },
        {
          intro: 'Ievadi vēlamos partnera kritērijus, meklē starp visatbilstošākajiem un novērtē katru ar "Man patīk!", "Nē, nebūs" vai "Izlaist" (lietotājs Tev netiks rādīts līdz nākamajai dienai).',
          element: document.querySelector('.matches-tour-search'),
          position: bottomPosition,
          highlightClass: 'tourStep-highlight',
        },
        {
          intro: 'Apskati lietotājus, kuru profilus esi novērtējis ar "Man patīk!".',
          element: document.querySelector('.matches-tour-my-likes'),
          position: bottomPosition,
          highlightClass: 'tourStep-highlight',
        },
        {
          intro: 'Apskati lietotājus, kuri Tavu profilu novērtējuši ar "Man patīk!".',
          element: document.querySelector('.matches-tour-likes-me'),
          position: bottomPosition,
          highlightClass: 'tourStep-highlight',
          tooltipClass: 'tourStep-tooltip tourStep-tooltip--last',
        },
        /* {
          intro: 'Apskati visus lietotājus,
          kurus esi novērtējis ar "Patīk", "Nepatīk" vai "Izlaist".',
          element: document.querySelector('.matches-tour-my-history'),
          position: topPosition,
          highlightClass: 'tourStep-highlight',
          tooltipClass: 'tourStep-tooltip tourStep-tooltip--last',
        }, */
      ],
    });

    tour.init();
  };

  return (
    <div className={`matches-footer${pagination ? ' matches-footer--withPagination' : ''} tac`}>
      <div className="dib">
        <a href={window.location.href} onClick={matchesTour} className="tss tcb">Ceļvedis</a>
      </div>
      {/* <div className="dib mls mrs tclg">|</div>
      <div className="dib matches-tour-my-history">
        <a
          href="/matches/my_history"
          className="tss tcb"
          data-target="#main-panel"
        >
          Darbību vēsture
        </a>
      </div> */}
    </div>
  );
};

MatchesFooter.propTypes = {
  pagination: PropTypes.bool,
};

MatchesFooter.defaultProps = {
  pagination: false,
};

export default MatchesFooter;
